module.exports = new Promise((resolve, reject) => {
        (new Promise((resolve, reject) => {
    var remoteBaseUrl = "https://web-bundles.setel.com/prod/web-common/latest".replace(/\/$/, ''); // trim trailing slash
    // backward compat with old remotes
    (window._endpoints ??= {})["web-common"] = remoteBaseUrl;
    // adds "remoteEntry.js" filename
    var remoteEntryUrl = remoteBaseUrl + '/' + "remoteEntry.js";
    // load remote using our custom runtime
    __webpack_require__._mf_l(remoteEntryUrl, "web_common")
        .then(resolve)
        .catch(reject);
    }))
        .then((rrContainer) => {
            return rrContainer.get("./exposes/remote-runtime");
        })
        .then((getModule) => {
            var mod = getModule();
            var runtimeFn = mod.default || mod; // we always expect default export
            return runtimeFn({
    isModule: undefined,
    dynamicRemotesConfigUrl: "https://web-bundles.setel.com/data/prod/config/web-dashboard.json",
    defaultRemoteEntry: "remoteEntry.js",
    appName: "web-dashboard",
    appGlobalName: "web_dashboard",
    // @ts-ignore
    appPublicUrl: __webpack_require__.p,
    remoteName: "web-fuelling",
    remoteGlobalName: "web_fuelling",
    remoteImportName: "@setel/web-fuelling",
    remoteDefaultUrl: "https://web-bundles.setel.com/prod/web-fuelling/latest",
});
        })
        .then(resolve)
        .catch(reject);
    });